import { WorkOrderFilters } from "@myapp/contract";
import { normalizeFilters } from "../../../shared/lib/normalizeFilters";

export const workOrderKeys = {
  all: ["work-orders"] as const,

  lists: () => [...workOrderKeys.all, "list"] as const,

  list: (filters?: WorkOrderFilters) =>
    [...workOrderKeys.lists(), normalizeFilters(filters)] as const,

  details: () => [...workOrderKeys.all, "detail"] as const,

  detail: (workOrderId: string) =>
    [...workOrderKeys.details(), workOrderId] as const,
};
